module.exports = __webpack_public_path__ + "static/media/passo-2.63c670ec.png";